import React, { Component } from "react";
import { Button, Icon } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import ReactDOM from "react-dom";

let currentAlert = null;

export default class AlertBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isVisible: false,
    };
  }

  componentDidMount() {
    if (currentAlert && currentAlert !== this) {
      currentAlert.closeAlert(() => this.openAlert());
    } else {
      this.openAlert();
    }
  }

  openAlert = () => {
    this.setState({ isVisible: true }, () => {
      currentAlert = this;
    });
  };

  closeAlert = (callback) => {
    this.setState({ isVisible: false }, () => {
      currentAlert = null;
      if (callback) callback();
    });
  };

  componentWillUnmount() {
    if (currentAlert === this) currentAlert = null;
  }

  handleButton = () => {


      this.props.handleButton();
  };
  render() {
    if (!this.state.isVisible) return null;
    return ReactDOM.createPortal(
      <div className="alertBoxContainer">
        <Alert className="alertBoxError" severity={this.props.severity}>
          {this.props.text}
        </Alert>
        {this.props.buttonRefresh !== undefined && (
          <Button
            className="alertErrorButton"
            startIcon={<Icon>refresh</Icon>}
            variant="contained"
            component={this.props.buttonRefresh}
          >
            Discard changes
          </Button>
        )}
        {this.props.buttonDetails !== undefined && (
          <Button
          color="primary"
          variant="contained"
          style={{ marginLeft: "20px" }}
          onClick={this.handleButton}
        >
           Details
          </Button>

       )}


      </div>,
      document.getElementById("alert-root")
    );
  }
}